var map = {
	"./hw_days_year_eobs_1950.nc": 501744,
	"./hw_days_year_eobs_1951.nc": 677948,
	"./hw_days_year_eobs_1952.nc": 338956,
	"./hw_days_year_eobs_1953.nc": 201912,
	"./hw_days_year_eobs_1954.nc": 172548,
	"./hw_days_year_eobs_1955.nc": 433300,
	"./hw_days_year_eobs_1956.nc": 515040,
	"./hw_days_year_eobs_1957.nc": 36204,
	"./hw_days_year_eobs_1958.nc": 555416,
	"./hw_days_year_eobs_1959.nc": 560228,
	"./hw_days_year_eobs_1960.nc": 363324,
	"./hw_days_year_eobs_1961.nc": 370028,
	"./hw_days_year_eobs_1962.nc": 665287,
	"./hw_days_year_eobs_1963.nc": 25128,
	"./hw_days_year_eobs_1964.nc": 22724,
	"./hw_days_year_eobs_1965.nc": 501560,
	"./hw_days_year_eobs_1966.nc": 365216,
	"./hw_days_year_eobs_1967.nc": 484392,
	"./hw_days_year_eobs_1968.nc": 895796,
	"./hw_days_year_eobs_1969.nc": 325476,
	"./hw_days_year_eobs_1970.nc": 219396,
	"./hw_days_year_eobs_1971.nc": 437328,
	"./hw_days_year_eobs_1972.nc": 963304,
	"./hw_days_year_eobs_1973.nc": 368372,
	"./hw_days_year_eobs_1974.nc": 863532,
	"./hw_days_year_eobs_1975.nc": 90724,
	"./hw_days_year_eobs_1976.nc": 683312,
	"./hw_days_year_eobs_1977.nc": 566700,
	"./hw_days_year_eobs_1978.nc": 913820,
	"./hw_days_year_eobs_1979.nc": 524040,
	"./hw_days_year_eobs_1980.nc": 979792,
	"./hw_days_year_eobs_1981.nc": 620536,
	"./hw_days_year_eobs_1982.nc": 377100,
	"./hw_days_year_eobs_1983.nc": 510524,
	"./hw_days_year_eobs_1984.nc": 686084,
	"./hw_days_year_eobs_1985.nc": 282544,
	"./hw_days_year_eobs_1986.nc": 941683,
	"./hw_days_year_eobs_1987.nc": 56712,
	"./hw_days_year_eobs_1988.nc": 811084,
	"./hw_days_year_eobs_1989.nc": 343840,
	"./hw_days_year_eobs_1990.nc": 461996,
	"./hw_days_year_eobs_1991.nc": 989928,
	"./hw_days_year_eobs_1992.nc": 54332,
	"./hw_days_year_eobs_1993.nc": 40576,
	"./hw_days_year_eobs_1994.nc": 8184,
	"./hw_days_year_eobs_1995.nc": 883792,
	"./hw_days_year_eobs_1996.nc": 818208,
	"./hw_days_year_eobs_1997.nc": 584768,
	"./hw_days_year_eobs_1998.nc": 652270,
	"./hw_days_year_eobs_1999.nc": 325988,
	"./hw_days_year_eobs_2000.nc": 500884,
	"./hw_days_year_eobs_2001.nc": 631688,
	"./hw_days_year_eobs_2002.nc": 229508,
	"./hw_days_year_eobs_2003.nc": 265016,
	"./hw_days_year_eobs_2004.nc": 657384,
	"./hw_days_year_eobs_2005.nc": 627923,
	"./hw_days_year_eobs_2006.nc": 617952,
	"./hw_days_year_eobs_2007.nc": 264536,
	"./hw_days_year_eobs_2008.nc": 279708,
	"./hw_days_year_eobs_2009.nc": 871121,
	"./hw_days_year_eobs_2010.nc": 163960,
	"./hw_days_year_eobs_2011.nc": 301004,
	"./hw_days_year_eobs_2012.nc": 728976,
	"./hw_days_year_eobs_2013.nc": 241411,
	"./hw_days_year_eobs_2014.nc": 481900,
	"./hw_days_year_eobs_2015.nc": 477088,
	"./hw_days_year_eobs_2016.nc": 413024,
	"./hw_days_year_eobs_2017.nc": 134596,
	"./hw_days_year_eobs_2018.nc": 864768,
	"./hw_days_year_eobs_2019.nc": 870215,
	"./hw_days_year_eobs_2020.nc": 849716,
	"./hw_days_year_eobs_2021.nc": 987176,
	"./hw_days_year_eobs_2022.nc": 287560,
	"./hw_days_year_eobs_2023.nc": 332076,
	"./hw_days_year_eobs_2024.nc": 327264,
	"./hw_events_year_eobs_1950.nc": 632548,
	"./hw_events_year_eobs_1951.nc": 627736,
	"./hw_events_year_eobs_1952.nc": 108524,
	"./hw_events_year_eobs_1953.nc": 225135,
	"./hw_events_year_eobs_1954.nc": 462800,
	"./hw_events_year_eobs_1955.nc": 22488,
	"./hw_events_year_eobs_1956.nc": 910196,
	"./hw_events_year_eobs_1957.nc": 282748,
	"./hw_events_year_eobs_1958.nc": 750268,
	"./hw_events_year_eobs_1959.nc": 352456,
	"./hw_events_year_eobs_1960.nc": 575288,
	"./hw_events_year_eobs_1961.nc": 885664,
	"./hw_events_year_eobs_1962.nc": 421844,
	"./hw_events_year_eobs_1963.nc": 120612,
	"./hw_events_year_eobs_1964.nc": 608984,
	"./hw_events_year_eobs_1965.nc": 99820,
	"./hw_events_year_eobs_1966.nc": 243044,
	"./hw_events_year_eobs_1967.nc": 15852,
	"./hw_events_year_eobs_1968.nc": 295724,
	"./hw_events_year_eobs_1969.nc": 68532,
	"./hw_events_year_eobs_1970.nc": 492336,
	"./hw_events_year_eobs_1971.nc": 794039,
	"./hw_events_year_eobs_1972.nc": 105044,
	"./hw_events_year_eobs_1973.nc": 312283,
	"./hw_events_year_eobs_1974.nc": 717180,
	"./hw_events_year_eobs_1975.nc": 231312,
	"./hw_events_year_eobs_1976.nc": 90192,
	"./hw_events_year_eobs_1977.nc": 761596,
	"./hw_events_year_eobs_1978.nc": 889000,
	"./hw_events_year_eobs_1979.nc": 134140,
	"./hw_events_year_eobs_1980.nc": 267724,
	"./hw_events_year_eobs_1981.nc": 720384,
	"./hw_events_year_eobs_1982.nc": 948212,
	"./hw_events_year_eobs_1983.nc": 377892,
	"./hw_events_year_eobs_1984.nc": 150700,
	"./hw_events_year_eobs_1985.nc": 430572,
	"./hw_events_year_eobs_1986.nc": 312092,
	"./hw_events_year_eobs_1987.nc": 208144,
	"./hw_events_year_eobs_1988.nc": 836936,
	"./hw_events_year_eobs_1989.nc": 654248,
	"./hw_events_year_eobs_1990.nc": 153160,
	"./hw_events_year_eobs_1991.nc": 966236,
	"./hw_events_year_eobs_1992.nc": 629196,
	"./hw_events_year_eobs_1993.nc": 201088,
	"./hw_events_year_eobs_1994.nc": 157712,
	"./hw_events_year_eobs_1995.nc": 627184,
	"./hw_events_year_eobs_1996.nc": 928888,
	"./hw_events_year_eobs_1997.nc": 239892,
	"./hw_events_year_eobs_1998.nc": 489744,
	"./hw_events_year_eobs_1999.nc": 848516,
	"./hw_events_year_eobs_2000.nc": 173096,
	"./hw_events_year_eobs_2001.nc": 330824,
	"./hw_events_year_eobs_2002.nc": 611244,
	"./hw_events_year_eobs_2003.nc": 642808,
	"./hw_events_year_eobs_2004.nc": 749320,
	"./hw_events_year_eobs_2005.nc": 15976,
	"./hw_events_year_eobs_2006.nc": 154011,
	"./hw_events_year_eobs_2007.nc": 446512,
	"./hw_events_year_eobs_2008.nc": 815936,
	"./hw_events_year_eobs_2009.nc": 91392,
	"./hw_events_year_eobs_2010.nc": 7080,
	"./hw_events_year_eobs_2011.nc": 763464,
	"./hw_events_year_eobs_2012.nc": 818956,
	"./hw_events_year_eobs_2013.nc": 72984,
	"./hw_events_year_eobs_2014.nc": 336500,
	"./hw_events_year_eobs_2015.nc": 346488,
	"./hw_events_year_eobs_2016.nc": 479880,
	"./hw_events_year_eobs_2017.nc": 649208,
	"./hw_events_year_eobs_2018.nc": 916272,
	"./hw_events_year_eobs_2019.nc": 467988,
	"./hw_events_year_eobs_2020.nc": 692136,
	"./hw_events_year_eobs_2021.nc": 428144,
	"./hw_events_year_eobs_2022.nc": 78376,
	"./hw_events_year_eobs_2023.nc": 369868,
	"./hw_events_year_eobs_2024.nc": 640312,
	"./hw_meanmag_year_eobs_1950.nc": 2688,
	"./hw_meanmag_year_eobs_1951.nc": 112232,
	"./hw_meanmag_year_eobs_1952.nc": 825448,
	"./hw_meanmag_year_eobs_1953.nc": 974636,
	"./hw_meanmag_year_eobs_1954.nc": 99040,
	"./hw_meanmag_year_eobs_1955.nc": 873376,
	"./hw_meanmag_year_eobs_1956.nc": 864304,
	"./hw_meanmag_year_eobs_1957.nc": 520824,
	"./hw_meanmag_year_eobs_1958.nc": 259352,
	"./hw_meanmag_year_eobs_1959.nc": 202128,
	"./hw_meanmag_year_eobs_1960.nc": 464432,
	"./hw_meanmag_year_eobs_1961.nc": 12120,
	"./hw_meanmag_year_eobs_1962.nc": 725336,
	"./hw_meanmag_year_eobs_1963.nc": 530396,
	"./hw_meanmag_year_eobs_1964.nc": 393104,
	"./hw_meanmag_year_eobs_1965.nc": 838596,
	"./hw_meanmag_year_eobs_1966.nc": 754292,
	"./hw_meanmag_year_eobs_1967.nc": 370556,
	"./hw_meanmag_year_eobs_1968.nc": 962264,
	"./hw_meanmag_year_eobs_1969.nc": 828480,
	"./hw_meanmag_year_eobs_1970.nc": 140820,
	"./hw_meanmag_year_eobs_1971.nc": 173344,
	"./hw_meanmag_year_eobs_1972.nc": 852080,
	"./hw_meanmag_year_eobs_1973.nc": 727915,
	"./hw_meanmag_year_eobs_1974.nc": 777716,
	"./hw_meanmag_year_eobs_1975.nc": 376392,
	"./hw_meanmag_year_eobs_1976.nc": 184540,
	"./hw_meanmag_year_eobs_1977.nc": 946636,
	"./hw_meanmag_year_eobs_1978.nc": 236220,
	"./hw_meanmag_year_eobs_1979.nc": 949436,
	"./hw_meanmag_year_eobs_1980.nc": 656712,
	"./hw_meanmag_year_eobs_1981.nc": 16552,
	"./hw_meanmag_year_eobs_1982.nc": 838396,
	"./hw_meanmag_year_eobs_1983.nc": 361452,
	"./hw_meanmag_year_eobs_1984.nc": 840288,
	"./hw_meanmag_year_eobs_1985.nc": 690680,
	"./hw_meanmag_year_eobs_1986.nc": 601724,
	"./hw_meanmag_year_eobs_1987.nc": 516016,
	"./hw_meanmag_year_eobs_1988.nc": 890096,
	"./hw_meanmag_year_eobs_1989.nc": 437784,
	"./hw_meanmag_year_eobs_1990.nc": 661884,
	"./hw_meanmag_year_eobs_1991.nc": 375100,
	"./hw_meanmag_year_eobs_1992.nc": 553196,
	"./hw_meanmag_year_eobs_1993.nc": 192320,
	"./hw_meanmag_year_eobs_1994.nc": 82148,
	"./hw_meanmag_year_eobs_1995.nc": 854956,
	"./hw_meanmag_year_eobs_1996.nc": 267664,
	"./hw_meanmag_year_eobs_1997.nc": 909396,
	"./hw_meanmag_year_eobs_1998.nc": 566484,
	"./hw_meanmag_year_eobs_1999.nc": 154247,
	"./hw_meanmag_year_eobs_2000.nc": 567760,
	"./hw_meanmag_year_eobs_2001.nc": 204260,
	"./hw_meanmag_year_eobs_2002.nc": 308160,
	"./hw_meanmag_year_eobs_2003.nc": 629852,
	"./hw_meanmag_year_eobs_2004.nc": 385156,
	"./hw_meanmag_year_eobs_2005.nc": 364472,
	"./hw_meanmag_year_eobs_2006.nc": 142584,
	"./hw_meanmag_year_eobs_2007.nc": 276008,
	"./hw_meanmag_year_eobs_2008.nc": 558680,
	"./hw_meanmag_year_eobs_2009.nc": 788248,
	"./hw_meanmag_year_eobs_2010.nc": 87896,
	"./hw_meanmag_year_eobs_2011.nc": 917908,
	"./hw_meanmag_year_eobs_2012.nc": 357952,
	"./hw_meanmag_year_eobs_2013.nc": 439312,
	"./hw_meanmag_year_eobs_2014.nc": 441740,
	"./hw_meanmag_year_eobs_2015.nc": 442232,
	"./hw_meanmag_year_eobs_2016.nc": 30396,
	"./hw_meanmag_year_eobs_2017.nc": 417936,
	"./hw_meanmag_year_eobs_2018.nc": 742064,
	"./hw_meanmag_year_eobs_2019.nc": 992280,
	"./hw_meanmag_year_eobs_2020.nc": 670160,
	"./hw_meanmag_year_eobs_2021.nc": 313524,
	"./hw_meanmag_year_eobs_2022.nc": 395100,
	"./hw_meanmag_year_eobs_2023.nc": 764132,
	"./hw_meanmag_year_eobs_2024.nc": 26072
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 904300;